// extracted by mini-css-extract-plugin
module.exports = {"tableLoadingOverlay":"LoadingBox_tableLoadingOverlay__15k-w","loadingBox":"LoadingBox_loadingBox__3gzWZ"};